import { createFlagsHook } from '@omnea-app/fe-org-settings/createFlagsHook'

export const usePunchoutCataloguesLdFlags = createFlagsHook<typeof import('./flags.json')>()
